import { Column } from "@lightningjs/ui-components";
import { Hero } from "core.components";
export class HomeRows extends Column {
    set scrollFollower(component) {
        this._scrollFollower = component;
        this._scrollFollower.y = this.Items.y;
    }
    updatePositionOnAxis(item, position) {
        super.updatePositionOnAxis(item, position);
        if (item === this.Items && this._scrollFollower) {
            // Keep the Navbar attached to the hero using the same scroll transition.
            super.updatePositionOnAxis(this._scrollFollower, position);
        }
    }
    _getScrollY() {
        var _a, _b, _c;
        const { selected } = this;
        if (!selected)
            return undefined;
        const selectedY = (_a = selected.getSmooth("y")) !== null && _a !== void 0 ? _a : selected.y;
        // Align a focused hero with the viewport, wherever it sits in the page.
        if (selected instanceof Hero)
            return -selectedY;
        const scrollY = (this.h - selected.h) / 2 - selectedY;
        const last = (_b = this.items[this.items.length - 1]) !== null && _b !== void 0 ? _b : selected;
        const contentBottom = ((_c = last.getSmooth("y")) !== null && _c !== void 0 ? _c : last.y) + last.h;
        // Include a bottom gutter in the scroll bounds, except for full-screen rails.
        const bottomSpacing = last instanceof Hero ? 0 : HomeRows.SPACING;
        const minScrollY = Math.min(0, this.h - contentBottom - bottomSpacing);
        return Math.max(minScrollY, Math.min(0, scrollY));
    }
}
HomeRows.SPACING = 56;
export default HomeRows;
//# sourceMappingURL=HomeRows.js.map